//#region IMPORTS
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { updateInstoreTemplateAsync } from "../../features/instoreTemplates/instoreTemplatesSlice";
import { InstoreTemplate } from "../../models/instoreTemplate";
import { useAppDispatch } from "../../store/configureStore";
import { toBackendDate } from "../../helpers/toBackendDate";
import { toast } from "react-toastify";
import agent from "../../api/agent";
//#endregion

//#region INTERFACE
interface Props {
  instoreTemplate: InstoreTemplate;
  disabled: boolean;
}
//#endregion

export default function InstoreTemplatesTableRowActionActive({
  instoreTemplate,
  disabled,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region LOGIC
  // Fast toggle active
  const instoreTemplateActiveHandler = async () => {
    const togglePromise = (async () => {
      const { data } = await agent.InstoreTemplates.detail(instoreTemplate.id);

      const updatedData = {
        ...data,
        active: !data.active,
        from: toBackendDate(data.from),
        until: toBackendDate(data.until),
      };

      await dispatch(
        updateInstoreTemplateAsync({
          id: updatedData.id,
          values: updatedData,
        }),
      ).unwrap();
    })();

    toast.promise(togglePromise, {
      pending: "Changing template status… This may take a while.",
      success: "Template status change completed.",
      error: "Template status change failed.",
    });
  };
  //#endregion

  return (
    <button
      className="flex items-center justify-center"
      disabled={disabled}
      onClick={instoreTemplateActiveHandler}
    >
      {instoreTemplate.active ? (
        <CheckCircleIcon className="h-4 w-4 text-purple-500" />
      ) : (
        <XCircleIcon className="h-4 w-4 text-gray-400" />
      )}
    </button>
  );
}
